<div class="d-flex">
	<div class="colstat colstat-small">
		<label>{{ "version" | langVal }}</label>
		<app-gen-input
			#firstField
			type="textarea"
			tabindex="1"
			[isStatic]="disabled"
			[actualObj]="actObject"
			[errors]="errors"
			title_ph_lang="version"
			fieldName="description"
			autofocus="autofocus"
			(changeEvent)="validateAndSave('description')"
		>
		</app-gen-input>
	</div>
	<div class="colstat colstat-small-triple">
		<label>{{ "change_remarks" | langVal }}</label>
		<app-gen-input
			#firstField
			type="textarea"
			tabindex="-1"
			[isStatic]="disabled"
			[actualObj]="actObject"
			[errors]="errors"
			fieldName="change_remarks"

			(changeEvent)="validateAndSave('change_remarks')"
		>
		</app-gen-input>
	</div>
</div>
<div class="d-flex">
	<div class="w-100">
		<label>{{ "main_text" | langVal }}</label>
		<app-wysiwyg
			[actualObj]="actObject"
			[errors]="errors"
			[isStatic]="disabled"
			fieldName="main_text"
			(changeEvent)="validateAndSave('main_text')"
		/>
	</div>
</div>
<div>
	@if (actObject.id) {
		<h4 class="followup-title">{{ "policy_form_fields" | langVal }}</h4>
		<div class="d-flex">
			<div class="col-12">
				<fields
					[objectRow]="actObject"
					[disabled]="disabled"
				/>
			</div>
		</div>
	}
</div>

<div>
	@if (!actObject.id) {
		<app-btn-ext
			text="insert_policy_form_fields"
			[disabled]="!isFormSubmittable"
			(clickEv)="save()"
			[isSpin]="isSaving"
		/>
	}
</div>
